export default __webpack_public_path__ + "static/media/divider.450e00c3.svg";